import Button from 'antd-button-color'
import React, { useState } from 'react'
import to from 'await-to-js'
import { toast } from 'react-toastify'
import ServiceAPI from '~services/services'
import { Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons';

const RestartWorker = () => {
    const [switchLoading, setSwitchLoading] = useState<boolean>(false)

    const fucRestartWorker = async () => {
        setSwitchLoading(true)
        Modal.confirm({
            title: `คุณต้องการ Restart Woker?`,
            icon: <ExclamationCircleOutlined />,
            content: '',
            okText: 'ใช่',
            okType: 'danger',
            cancelText: 'ไม่',
            async onOk() {
                const [err, res] = await to(ServiceAPI.restartWorker())
                if (err) {
                    toast.error(err?.message as string)
                    setSwitchLoading(false)
                } else {
                    toast.success(res.message)
                    setSwitchLoading(false)
                }
            },
            onCancel() {
                setSwitchLoading(false)
            },
        });
    }
    return (
        <Button type="info" className="text-white" onClick={fucRestartWorker} loading={switchLoading}>
            <i className="fa-solid fa-repeat me-2"></i>
            Restart Worker
        </Button>
    )
}

export default RestartWorker
